import { Box } from '@factorialco/deprecated-design-system'

import { ContentViewProps } from 'modules/trainings/components/content/types'
import { PageBlock } from 'modules/trainings/lib/content/PageBlock'

export const PageBlockView = ({ contentItem }: ContentViewProps<PageBlock>) => {
  return (
    <Box style={{ maxWidth: '720px', width: '100%', gap: '1rem' }}>
      <h2 className="text-3xl font-semibold f1-foreground">{contentItem.title}</h2>

      {contentItem.thumbnail.url && (
        <Box style={{ borderRadius: '1rem', overflow: 'hidden' }}>
          <img
            src={contentItem.thumbnail.url}
            alt={contentItem.title}
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      )}

      {contentItem.description && (
        <div
          className="text-base text-f1-foreground-secondary"
          style={{ lineHeight: '1.6' }}
          dangerouslySetInnerHTML={{ __html: contentItem.description }}
        />
      )}
    </Box>
  )
}
